import { Badge } from '@avanta/shared/components/ui/Badge';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { cn } from '@avanta/shared/utils/cn';
import { useTranslation } from 'react-i18next';
import { TAG_DIRECTION, type TagListProps } from 'components/TagList/types';
import { type TagText } from 'types/wellbeing';

export const TagList = ({
  tagsText,
  direction = 'vertical',
}: TagListProps): React.ReactElement | null => {
  const { i18n } = useTranslation(LOCIZE_NS.WELL_BEING);
  const currentLang = i18n.language as keyof TagText['i18n'];

  if (!tagsText || tagsText.length === 0) {
    return null;
  }

  return (
    <div
      className={cn(
        'flex gap-2',
        direction === TAG_DIRECTION.VERTICAL && 'flex-col gap-1 items-end'
      )}
    >
      {tagsText.map((tag, index) => (
        <Badge size="sm" className={cn('border-0', tag.className)} key={`${tag.id}-${index}`}>
          {tag.i18n[currentLang] || tag.i18n.es}
        </Badge>
      ))}
    </div>
  );
};
